import * as React from "react";
import { cn } from "./utils";

interface ComingSoonPillProps {
  label?: string;
  className?: string;
}

export function ComingSoonPill({
  label = "Coming Soon",
  className,
}: ComingSoonPillProps) {
  return (
    <span
      className={cn(
        "text-red-600 font-semibold text-sm bg-red-50 px-3 py-1 rounded-full border border-red-200",
        className,
      )}
    >
      {label}
    </span>
  );
}



